var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_8281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 2.0625C6.6825 2.0625 2.0625 6.6825 2.0625 12.375C2.0625 18.0675 6.6825 22.6875 12.375 22.6875C18.0675 22.6875 22.6875 18.0675 22.6875 12.375C22.6875 6.6825 18.0675 2.0625 12.375 2.0625ZM12.3751 17.5312C11.8079 17.5312 11.3438 17.0672 11.3438 16.5V12.375C11.3438 11.8078 11.8079 11.3437 12.3751 11.3437C12.9422 11.3437 13.4063 11.8078 13.4063 12.375V16.5C13.4063 17.0672 12.9422 17.5312 12.3751 17.5312ZM11.3438 9.2811H13.4063V7.2186H11.3438V9.2811Z",
    fill: "#395B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_8281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-info.568d1c19add2867f42de652b3bf99950.svg";